// Hero slideshow watchdog.
//
// Symptom seen in Clarity recordings: the strip is parked between two slides (both visible,
// with the gap in the middle) while the captions and dots keep advancing.
//
// Cause: Flickity animates with a self-rescheduling requestAnimationFrame chain and guards it
// with `isAnimating`. When a tab is frozen mid-transition (mobile browsers do this aggressively,
// desktop Chrome too) the pending frame can be dropped, so the chain never resumes while
// `isAnimating` stays true. The autoplay player runs on setTimeout and resumes fine, so every
// later `next()` updates `selectedIndex` — captions and dots move — but `startAnimation()`
// returns immediately and the strip never moves again.
//
// This checks a few times a second:
//   * settled but off-grid  -> snap back to the selected slide;
//   * "animating" but x has not moved for ~1.4 s -> the frame chain is dead: clear the flag and
//     snap back, which lets the next transition start a fresh chain.
// While a transition is really running, x keeps changing and nothing here fires.
(function () {
  var TOLERANCE = 6;
  var INTERVAL = 700;
  var STALL_TICKS = 2; // ~1.4 s without movement while "animating"

  var state = typeof WeakMap === 'function' ? new WeakMap() : null;

  function getState(el) {
    if (!state) return el.__guard || (el.__guard = {});
    var s = state.get(el);
    if (!s) { s = {}; state.set(el, s); }
    return s;
  }

  function isAligned(el) {
    var viewport = el.querySelector('.flickity-viewport');
    if (!viewport) return true;
    var left = viewport.getBoundingClientRect().left;
    var cells = el.querySelectorAll('.banner');
    if (!cells.length) return true;
    for (var i = 0; i < cells.length; i++) {
      if (Math.abs(cells[i].getBoundingClientRect().left - left) < TOLERANCE) return true;
    }
    return false;
  }

  function realign(flickity) {
    try {
      flickity.isAnimating = false;
      flickity.velocity = 0;
      flickity.select(flickity.selectedIndex, false, true);
    } catch (e) {}
  }

  function check(el) {
    var flickity = el.slider;
    if (!flickity || flickity.isPointerDown || flickity.isDragging) return;

    var s = getState(el);

    if (isAligned(el)) {
      s.stall = 0;
      s.x = flickity.x;
      return;
    }

    if (!flickity.isAnimating) {
      realign(flickity);
      s.stall = 0;
      return;
    }

    // Claims to be animating: only act once x has stopped changing.
    if (s.x === flickity.x) {
      s.stall = (s.stall || 0) + 1;
      if (s.stall >= STALL_TICKS) {
        realign(flickity);
        s.stall = 0;
      }
    } else {
      s.stall = 0;
      s.x = flickity.x;
    }
  }

  function sweep(sliders) {
    for (var i = 0; i < sliders.length; i++) check(sliders[i]);
  }

  function start() {
    var sliders = document.querySelectorAll('slideshow-element');
    if (!sliders.length) return;

    setInterval(function () {
      if (document.hidden) return;
      sweep(sliders);
    }, INTERVAL);

    // Coming back from a frozen tab is exactly when the frame chain is found dead.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      setTimeout(function () { sweep(sliders); }, 400);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
